module.exports = __webpack_public_path__ + "fonts/WorkSans-Black.fef7be3.ttf";